export default {
  ACCESS_CATEGORY: "ACCESSO",
  XCONNECT_CATEGORY: "XCONNECT",
};
